// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"pq","header":"pr","headline":"ps","closeIcon":"pt","modalCloseIcon":"pu"};